import i18n from "components/i18n";

const fetchWithLocale = async (url, options = {}) => {
  const headers = new Headers(options.headers || {});
  const currentLanguage = i18n.language || 'en';
  
  // Essential headers for cross-origin requests
  headers.set("Accept-Language", currentLanguage);
  headers.set("X-Language", currentLanguage);
  headers.set("Origin", window.location.origin);

  return fetch(url, {
    ...options,
    credentials: 'include', // Required for cookies
    headers,
    mode: 'cors' // Explicit CORS mode
  });
};

export default fetchWithLocale;